import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import OrganizationUserEntity from '@/entity/organization-user/OrganizationUserEntity';
import useColorService from '@/services/ColorService';
import UserClientEntity from '@/entity/user-client/UserClientEntity';

type Props = SetupProps<typeof OrganizationUserRolesSetupService.props>
type Role = IRoleUserDetailModel | IRoleUserModel;

export default class OrganizationUserRolesSetupService extends BaseSetupService<Props> {
	static readonly props = {
		readonly: Boolean,
		userIsAgencyWatchingClient: Boolean,
		user: {
			type: Object as PropType<OrganizationUserEntity | UserClientEntity>,
			default: undefined,
		},
	};

	swapColor = useColorService().swapColor;

	private readonly state = reactive({ activeRoles: [] as number[] });

	get userRolesPermissions (): Armado.RolePermission.PermissionListItem[] {
		if (!this.props.user?.roles) return [];

		return this.props.user.roles.map((ur) => {
			if (!ur.organizationRole?.rolePermissions) return [];

			return ur.organizationRole.rolePermissions.map(p => ({
				id: p.id,
				value: p.value,
				action: p.action,
				roleId: ur.organizationRole?.id,
				color: this.swapColor(ur.organizationRole?.colorName),
				active: this.roleIsActive(ur),
			}));
		}).flat();
	}


	constructor (props?: Props) {
		super(props);
	}


	roleIsActive (role: Role) {
		if (!role.organizationRole?.id) return false;
		return !this.state.activeRoles.length || this.state.activeRoles.includes(role.organizationRole.id);
	}

	toggleRole (role: Role) {
		if (!role.organizationRole?.id) return;
		this.state.activeRoles.toggle(role.organizationRole.id);
	}

	isOrganizationUser (): this is {props: {user: OrganizationUserEntity }} {
		return this.props.user instanceof OrganizationUserEntity;
	}
}
